import $ from "jquery";

export function personalize() {
  if (typeof document === "undefined") return;

  $(document).trigger("userDataReady");
  document.dispatchEvent(new CustomEvent("userDataReady"));
}
